import { MapTo } from '@adobe/aem-react-editable-components';
import NextSteps, { NextStepsEditConfig } from './NextSteps';

export default MapTo('cob-corp-acquisition/components/creditonebank/next-steps')(NextSteps, NextStepsEditConfig);